<template>
  <div>
   <div class="login" >
      <a-input addon-before="用户："  default-value="" v-model="name"/>
    </div> 
    <div class="login" >
      <a-input-password addon-before="密码："  default-value="" v-model="password"/>
    </div>
    <div class="login" >
      <a-input-password addon-before="确认密码："  default-value="" v-model="repassword"/>
    </div>
    <div class="login" >
      <a-button type='primary' @click="submit">确定</a-button>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      name:"",
      password:"",
      repassword:""
    }
  },

    methods:{
        submit (){
            let param = {
              user:this.name,
              password:this.password
            }
            let obj = this.$qs.stringify(param)
            if(this.password==""||this.name=="")
            {
              alert("请完善信息！")
            }
            else
            {
              if(this.password != this.repassword)
              {
                alert("两次密码输入不一致！")
                this.password = ""
                this.repassword = ""
              }
              else
              {
                this.$axios({
                method:'post',
                url:'/api/user/regist',
                data: obj
                }).then((response) =>{          //这里使用了ES6的语法
                
                console.log(response)       //请求成功返回的数据
                let result = response.data
                if(result["result"])
                {
                  this.$router.push('/home')
                }
                }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
                })
              }
            }

        }
    }
}
</script>>
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.login {
  margin-top:20px;
  margin-left:auto;
  margin-right:auto;
  width:300px

}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue